<script setup lang="ts">
import { toRefs } from 'vue';
import { IPolicyMartime } from '../../types/policy.type';
import { formatDateAndHourSpanish } from '../../helpers/functionsMoment';
import { useI18n } from 'vue-i18n'

const { t } = useI18n();
interface Props {
  policyData: IPolicyMartime;
}
const props = defineProps<Props>();
const { policyData } = toRefs(props);
</script>

<template>
	<p>
	  <strong>{{ t('operaciones.modal_content_policy_maritime.id') }}: </strong>
	  {{ policyData.id }}
	</p>
	<p>
	  <strong>{{ t('operaciones.modal_content_policy_maritime.limite_indemnizacion') }}: </strong>
	  $ {{ policyData.indemnificationLimit }}
	</p>
	<p>
	  <strong>{{ t('operaciones.modal_content_policy_maritime.precio_total') }}: </strong>
	  $ {{ policyData.fullPrice }}
	</p>
	<p>
	  <strong>{{ t('operaciones.modal_content_policy_maritime.naviera') }}: </strong>
	  {{ policyData.shippingCompany }}
	</p>
	<p>
	  <strong>{{ t('operaciones.modal_content_policy_maritime.puerto_salida') }}: </strong>
	  {{ policyData.portDeparture }}
	</p>
	<p>
	  <strong>{{ t('operaciones.modal_content_policy_maritime.pais_salida') }}: </strong>
	  {{ policyData.countryDeparture?.description }}
	</p>
	<p>
		<strong>{{ t('operaciones.modal_content_policy_maritime.puerto_arribo') }}: </strong>
		{{ policyData.portArrival }}
	</p>
	<p>
	  <strong>{{ t('operaciones.modal_content_policy_maritime.pais_arribo') }}: </strong>
	  {{ policyData.countryArrival?.description }}
	</p>
	<p>
	  <strong>{{ t('operaciones.modal_content_policy_maritime.fecha_inicio_viaje') }}: </strong>
	  {{ formatDateAndHourSpanish(policyData.travelStartDate) }}
	</p>
	<p>
	  <strong>{{ t('operaciones.modal_content_policy_maritime.fecha_fin_viaje') }}: </strong>
	  {{ formatDateAndHourSpanish(policyData.travelEndDate) }}
	</p>
	<p>
	  <strong>{{ t('operaciones.modal_content_policy_maritime.tipo_contenedor') }}: </strong>
	  {{ policyData.typeContainer.typeName }}
	</p>
	<p>
	  <strong>{{ t('operaciones.modal_content_policy_maritime.numero_contenedor') }}: </strong>
	  {{ policyData.containerNumber }}
	</p>
	<p>
	  <strong>{{ t('operaciones.modal_content_policy_maritime.cliente') }}: </strong>
	  {{ policyData.client.tradeName }}
	</p>
	<p>
	  <strong>{{ t('operaciones.modal_content_policy_maritime.direccion_cliente') }}: </strong>
	  {{ policyData.client.address }}
	</p>
	<p>
	  <strong>{{ t('operaciones.modal_content_policy_maritime.telefono_cliente') }}: </strong>
	  {{ policyData.client.phone1 }}
	</p>
	<p v-if="policyData.client.rfc">
	  <strong>{{ t('operaciones.modal_content_policy_maritime.rfc_cliente') }}: </strong>
	  {{ policyData.client.rfc }}
	</p>
	<p v-if="policyData.client.cuit">
	  <strong>{{ t('operaciones.modal_content_policy_maritime.cuit_cliente') }}: </strong>
	  {{ policyData.client.cuit }}
	</p>
	<p v-if="policyData.client.rut">
	  <strong>{{ t('operaciones.modal_content_policy_maritime.rut_cliente') }}: </strong>
	  {{ policyData.client.rut }}
	</p>
	<p>
	  <strong>{{ t('operaciones.modal_content_policy_maritime.descripcion_activo') }}: </strong>
	  {{ policyData.asset.description }}
	</p>
	<p>
	  <strong>{{ t('operaciones.modal_content_policy_maritime.tipo_riesgo') }}: </strong>
	  {{ policyData.asset.riskType.description }}
	</p>
	<p>
	  <strong>{{ t('operaciones.modal_content_policy_maritime.compania_gps') }}: </strong>
	  {{ policyData.companyGPS.description }}
	</p>
	<p>
	  <strong>{{ t('operaciones.modal_content_policy_maritime.pais') }}: </strong>
	  {{ policyData.country.description }}
	</p>
  </template>

